// Provider photos ship as static files in public/images/providers/, named by DrChrono provider ID
// (the same ID the self-scheduling directory and appointment details already carry), so rendering
// one needs no API call at all - Apache serves it straight from the web-portal build. A provider
// with no file on disk just 404s, and MUI's Avatar falls back to its placeholder child on a failed
// image load, so no separate "has photo" lookup is needed either.
export const providerPhotoUrl = (providerId: number | undefined): string | undefined =>
  providerId ? `${process.env.PUBLIC_URL}/images/providers/${providerId}.webp` : undefined;
